import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React, { useState } from 'react';

import type { ILineItem } from '@feathr/blackbox';
import type { Bill } from '@feathr/blackbox';
import type { ISorted } from '@feathr/components';
import { Table } from '@feathr/components';

import BillColumns from './BillColumns';

interface IProps {
  bill: Bill;
  buildLineItemUrl?: (eventId: string, campaignId: string) => string;
}

function BillTable({ bill, buildLineItemUrl }: Readonly<IProps>): JSX.Element {
  const [sort, setSort] = useState<ISorted[]>([{ id: 'description' }]);

  let sortedItems: ILineItem[] = bill.isPending ? [] : bill.get('line_items', []);
  sort.forEach((s) => {
    if (s.id === 'description') {
      // Cannot sort observable in place, so make a copy using slice().
      sortedItems = sortedItems
        .slice()
        .sort((a, b) =>
          s.desc
            ? b.description.localeCompare(a.description)
            : a.description.localeCompare(b.description),
        );
    } else if (s.id === 'price') {
      // Cannot sort observable in place, so make a copy using slice().
      sortedItems = sortedItems
        .slice()
        .sort((a, b) => (s.desc ? b.price - a.price : a.price - b.price));
    }
  });

  function handleSortChange(newSort: ISorted[]): void {
    setSort(newSort);
  }

  return (
    <Table<ILineItem>
      columns={BillColumns(sortedItems, bill.get('event_id'), buildLineItemUrl)}
      idKey={'campaign_id'}
      isLoading={bill.isPending}
      isPaginated={false}
      items={sortedItems}
      noDataText={'No data'}
      onSortChange={handleSortChange}
      sort={sort}
    />
  );
}

export default observer(BillTable);
